var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "serach-box-head" }, [
    _c("div", { staticClass: "searchbutton" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.input,
            expression: "input"
          }
        ],
        attrs: {
          type: "text",
          placeholder: "Type to search for a feature or a project..."
        },
        domProps: { value: _vm.input },
        on: {
          click: function($event) {
            return _vm.onChange($event)
          },
          keyup: function($event) {
            return _vm.result()
          },
          input: function($event) {
            if ($event.target.composing) {
              return
            }
            _vm.input = $event.target.value
          }
        }
      })
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.flagForm && _vm.input,
            expression: "flagForm && input"
          }
        ],
        ref: "popup",
        staticClass: "search-result"
      },
      [
        _c("h6", [_vm._v("SEARCH OPTIONS")]),
        _vm._v(" "),
        _c(
          "ul",
          [
            _c("li", [
              _c(
                "a",
                {
                  attrs: {
                    href: "/view-all-projects?keyword=" + _vm.input,
                    target: "_blank"
                  }
                },
                [
                  _vm._m(1),
                  _vm._v(" "),
                  _c("h5", [
                    _vm._v("Project search term: "),
                    _c("span", { staticClass: "searchKey" }, [
                      _vm._v(_vm._s(_vm.input))
                    ])
                  ]),
                  _vm._v(" "),
                  _vm._m(2)
                ]
              )
            ]),
            _vm._v(" "),
            _vm._l(_vm.searchResult, function(result) {
              return _vm.searchResult
                ? _c("li", { key: result.id }, [
                    _c(
                      "a",
                      {
                        attrs: {
                          href: result.page_url,
                          target: result.external_link === "yes" ? "_blank" : ""
                        }
                      },
                      [
                        _vm._m(3, true),
                        _vm._v(" "),
                        _c("h5", [
                          _vm._v("Page search: "),
                          _c("span", { staticClass: "searchKey" }, [
                            _vm._v(_vm._s(result.page_name))
                          ])
                        ]),
                        _vm._v(" "),
                        _vm._m(4, true)
                      ]
                    )
                  ])
                : _vm._e()
            })
          ],
          2
        )
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("button", { attrs: { type: "search" } }, [
      _c("img", {
        attrs: {
          src: "/static/front/images/menu-images/search-button.svg",
          alt: "srach"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "search-icon" }, [
      _c("img", {
        attrs: {
          src: "/static/front/images/menu-images/search-button.svg",
          alt: "search"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "redirect-link" }, [
      _c("img", {
        attrs: {
          src: "/static/front/images/menu-images/redirect-icon.svg",
          alt: "search"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "search-icon" }, [
      _c("img", {
        attrs: {
          src: "/static/front/images/menu-images/search-button.svg",
          alt: "search"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "redirect-link" }, [
      _c("img", {
        attrs: {
          src: "/static/front/images/menu-images/redirect-icon.svg",
          alt: "search"
        }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d576cffc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d576cffc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/business/SearchKeyword.vue
// module id = null
// module chunks = 